<template>
  <div>
    <label v-if="label" v-bind="labelBindings">{{ label }}</label>
    <p class="text-center">{{ rangeLabel(value) }}</p>
    <input
        type="range"
        :min="min"
        :max="max"
        :step="step"
        v-bind="inputBindings"
        v-on="inputEvents"
    >
    <p v-if="invalid" class="text-danger">{{ errorMessage }}</p>
  </div>
</template>
<script>
import BaseInput from './BaseInput'

export default {
  extends: BaseInput,
  props: {
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    step: {
      type: Number,
      default: 1
    },
    rangeLabel: {
      type: Function,
      default () {
        return value => value
      }
    }
  },

  computed: {
    inputBindings () {
      return {
        id: this.id,
        value: this.value,
        'class': 'form-range'
      }
    }
  }
}
</script>
